.borderedButton {
  border: 1px solid var(--colors-grays-light);
  height: 32px;
  width: 32px;
  padding: 8px;
}
